import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

export class MobileComponent {
  isMobile: boolean = false;

  constructor(private breakpointObserver: BreakpointObserver) {
    this.breakpointObserver.observe([Breakpoints.Handset, Breakpoints.TabletPortrait]).subscribe(result => {
      this.isMobile = result.matches;
    });
  }
}
